import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useSearchConfigContext } from '../../common/search-config-provider';
import { JiraSearchClientProvider } from './jira-search-provider';
export var JiraSearchProviderWithSearchConfig = function JiraSearchProviderWithSearchConfig(props) {
  var _useSearchConfigConte = useSearchConfigContext(),
    jiraSites = _useSearchConfigConte.jiraSites;
  return /*#__PURE__*/React.createElement(JiraSearchClientProvider, _extends({}, props, {
    sites: jiraSites
  }));
};